import { Controller } from 'stimulus';
import DOMPurify from 'dompurify';
let debounce = require('lodash/debounce');

export default class extends Controller {

  static targets = ['userRow', 'form', 'table', "selection", "orderLink"]

  connect() {
    this.addSelectParam();
  }

  initialize() {
    this.searchUsers = debounce(this.searchUsers, 200).bind(this)
    this.searchRequest = null;
  }


  buildRows(results) {
    console.log(results);
    return results.map(user => {
      return `
        <tr class="js-table-row"
          tabindex="0">
          <td class="cell-data cell-data--number">
            ${DOMPurify.sanitize(user.id)}
          </td>
          <td class="cell-data cell-data--string">
            <a href="/admin/users/${DOMPurify.sanitize(user.id)}" class="action-show">
              ${DOMPurify.sanitize(user.name)}
            </a>
          </td>
          <td class="cell-data cell-data--belongs-to">
            <a href="/admin/enterprises/${DOMPurify.sanitize(user.enterprise_id)}">${DOMPurify.sanitize(user.enterprise ? user.enterprise.name : "")}</a>
          </td>
          <td class="cell-data cell-data--belongs-to">
            ${user.sites !== [] ? DOMPurify.sanitize(user.sites.map(site => site.name).join(', ')) : ""}
          </td>
          <td class="cell-data cell-data--has_many">
            ${DOMPurify.sanitize(user.pps.length) || 0} plans
          </td>
          <td class="cell-data cell-data--has_many">
            ${DOMPurify.sanitize(user.roles.join(', '))}
          </td>
          <td class="cell-data">
            <a class="position-absolute" href="/admin/users/${DOMPurify.sanitize(user.id)}">
              <img class="svg-arrow" src="/arrow_right.svg">
            </a>
          </td>
        </tr>
      `
    }).join('');
  }

  searchUsers(event) {
    const query = event.target.value;
    if (this.searchRequest) {
      this.searchRequest.abort();
    }
    this.searchRequest = $.get(`/users/search.json?query=${query}`).done(results => {
      const newRows = this.buildRows(results);
      this.tableTarget.innerHTML = newRows;
    }).fail(err => console.log(err));
  }

  // Update order_by link in table header to paginate the results corresponding to the entreprise selection
  addSelectParam() {
    const param = this.selectionTargets.find(input => input.checked).value;
    this.orderLinkTargets.forEach(link => {
      const path = link.getAttribute('href');
      link.setAttribute('href', `${path}&enterpriseSelect=${param}`);
    });
  }

  submitForm() {
    this.formTarget.submit();
  }
}
